import { createAccount, updateAccount } from "graphql/mutations";
import { getAccount, listAccounts } from "graphql/queries";
import {
  updateLoader,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { store } from "Store/store";
import { ExecuteMutation, ExecuteQuery } from "Utility/Api";

/** Find account by email (e.g. for Google sign-in when username is not in Cognito). Returns account or null. */
export const getAccountByEmail = async (email) => {
  if (!email) return null;
  try {
    const res = await ExecuteQuery(listAccounts, {
      filter: { email: { eq: email } },
      limit: 1,
    });
    const item = res?.items?.[0];
    return item || null;
  } catch (e) {
    return null;
  }
};

export const createAccountAction = (input) => {
  return ExecuteMutation(createAccount, { input });
};

export const updateAccountDetails = async (input) => {
  let updatedInput = { ...input, isDraft: true };
  try {
    store.dispatch(updateUserDetailsInReducer(input));
    store.dispatch(updateLoader(true));
    var res = await ExecuteMutation(updateAccount, { input: updatedInput });
    store.dispatch(updateUserDetailsInReducer(res));
    store.dispatch(updateLoader(false));
  } catch (error) {
    console.log(error, "error in updateAccountDetails");
  }
  return res;
};

export const getAccountDetails = async (username) => {
  try {
    // store.dispatch(updateLoader(true));
    var res = await ExecuteQuery(getAccount, { username });
    store.dispatch(updateUserDetailsInReducer(res));
    store.dispatch(updateLoader(false));
  } catch (error) {
    console.log(error);
  }
  return res;
};
